import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const Credits = ({ credits }) => (
  <div className='full-width credits-container'>
    <div className='credits'>
      {documentToReactComponents(credits, {
        renderText: text => text.split('\n').map((text, i) => [i > 0 && <br />, text])
      })}
    </div>
  </div>
)

export default Credits
